import CONSTANTS from '../../constants';

export function categories(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.POS.GET.CATEGORIES:
            return action.categories;
        default:
            return state
    }
}